<template>
  <div class="color-select">
    <h3>{{ $t('group.editMode.changeTagColor') }}</h3>

    <div class="chips">
      <ul>
        <li v-for="chip in colorList"
            :key="`color${chip.colorId}`">
          <button :style="{ 'background-color': chip.colorHex }"
                  @click="setColor(chip)">
            <i class="icon icon--check-white-size16"
               :class="{ checked: chip.colorHex === original.colorHex || chip.colorHex === color.colorHex,
                         original: chip.colorHex === original.colorHex && original.colorHex !== color.colorHex && chip.colorHex !== color.colorHex }"></i>
          </button>
        </li>
      </ul>
    </div>

    <div class="buttons">
      <ui-button @click="$emit('onCancel')">
        <span v-html="$t('common.cancel')"></span>
      </ui-button>
      <ui-button :primary="true"
                 :disabled="original.colorId === color.colorId"
                 @click="$emit('onSubmit', color)">
        <span v-html="$t('common.confirm')"></span>
      </ui-button>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'TagColor',
  components: {
    UiButton
  },
  props: ['original', 'colorList'],
  computed: {
    sid () {
      return this.$route.query.sid
    }
  },
  created () {
    this.color = this.original
  },
  methods: {
    setColor (chip) {
      this.color = chip
    }
  },
  data () {
    return {
      color: {}
    }
  }
}
</script>

<style lang="scss" scoped>
.color-select {
  width: 430px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #fff;
  text-align: center;

  h3 {
    padding: 30px 30px 19px 30px;
    font-size: 15px;
    font-weight: 500;
    text-align: left;
    color: #2f2f2f;
  }

  .chips {
    margin: 0 30px;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    padding: 19px 10px 17px;

    li {
      display: inline-block;
      vertical-align: top;
      padding: 7px 8px;
    }

    button {
      width: 24px;
      height: 24px;
      border-radius: 24px;
      border: solid 2px transparent;
      transition: border-color 0.2s ease,
                  box-shadow 0.2s ease;

      &:hover {
        border-color: #ffffff;
        box-shadow: 0 7px 12px -3px rgba(0, 0, 0, 0.5), 0 0 0 2px #289eef;
      }

      .icon {
        margin-top: 3px;
        opacity: 0;
        transition: opacity 0.2s ease;

        &.checked {
          opacity: 1;
        }

        &.original {
          opacity: 0.3;
        }
      }
    }
  }

  .buttons {
    padding: 25px 20px 23px;

    .ui-btn {
      min-width: 90px;
      margin: 0 2px 0 3px;
    }
  }
}
</style>
